import { render } from "./DetailsSection.vue?vue&type=template&id=d2b5547e&scoped=true"
import script from "./DetailsSection.js?vue&type=script&lang=js"
export * from "./DetailsSection.js?vue&type=script&lang=js"

import "./DetailsSection.scss?vue&type=style&index=0&id=d2b5547e&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./DetailsSection.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Firshadck%2Fprojects%2Fsunrise-spa%2Fsrc%2Fpresentation%2Ffashion%2FPageProductDetail%2FProductInfo%2FDetailsSection%2FDetailsSection.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b5547e"]])

export default __exports__